// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import Link from "next/link";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as HeaderModuleScss from "../styles/Header.module.scss";

var styles = HeaderModuleScss;

function LegalHeader(Props) {
  var location_icon = Props.location_icon;
  var company_info = Props.company_info;
  var refund_policy_link = Props.refund_policy_link;
  var terms_of_service_link = Props.terms_of_service_link;
  return React.createElement("div", {
              className: styles["compony-info"]
            }, React.createElement("div", {
                  className: styles["compony-name"]
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: location_icon.path,
                      height: 24.0,
                      width: 24.0,
                      quality: 100.0,
                      alt: location_icon.alt_text
                    }), React.createElement("div", undefined, company_info)), React.createElement("div", {
                  className: styles["links-container"]
                }, React.createElement(Link, {
                      href: terms_of_service_link.link,
                      children: terms_of_service_link.label
                    }), React.createElement(Link, {
                      href: refund_policy_link.link,
                      children: refund_policy_link.label
                    })));
}

var Link$1;

var make = LegalHeader;

export {
  styles ,
  Link$1 as Link,
  make ,
}
/* styles Not a pure module */
